export default __webpack_public_path__ + "static/media/image-not-found.298b9820.png";